import css from 'styled-jsx/css';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .FinancesPage {
    width: 100%;
    padding: 24px 0 24px 24px;
  }

  .FinancesPage__tabs {
    .Tabs__tab {
      @include respond-to(sm) {
        margin: 0 30px 20px 0 !important;

        &:last-child {
          margin: 0 0 20px 0 !important;
        }
      }
    }
  }

  .Tabs__content {
    background: white;
    border-radius: 16px;
    padding: 24px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;

    @include respond-to(sm) {
      padding: 16px;
    }
  }

  /* Ensure rt-thead and rt-tbody match rt-table width */
  .FinancesPage__deposits-tab .PaymentsTable .ReactTable .rt-thead,
  .FinancesPage__deposits-tab .PaymentsTable .ReactTable .rt-tbody,
  .FinancesPage__withdrawals-tab .PaymentsTable .ReactTable .rt-thead,
  .FinancesPage__withdrawals-tab .PaymentsTable .ReactTable .rt-tbody {
    display: flex !important;
    flex: 1 1 auto !important;
    min-width: max-content !important;
    width: auto !important;
  }

  /* CRM Deposits Tab - specific column widths */
  .FinancesPage__deposits-tab .PaymentsTable .ReactTable .rt-thead .rt-tr .rt-th:first-child,
  .FinancesPage__deposits-tab .PaymentsTable .ReactTable .rt-tbody .rt-tr-group .rt-tr .rt-td:first-child {
    flex: 80 0 auto !important;
    min-width: 80px !important;
    width: 80px !important;

    @include respond-to(sm) {
      flex: 60 0 auto !important;
      min-width: 60px !important;
      width: 60px !important;
    }
  }

  .FinancesPage__deposits-tab .PaymentsTable .ReactTable .rt-thead .rt-tr .rt-th:nth-child(2),
  .FinancesPage__deposits-tab .PaymentsTable .ReactTable .rt-tbody .rt-tr-group .rt-tr .rt-td:nth-child(2) {
    flex: 200 0 auto !important;
    min-width: 200px !important;
    width: 200px !important;

    @include respond-to(sm) {
      flex: 150 0 auto !important;
      min-width: 180px !important;
      width: 180px !important;
    }
  }

  .FinancesPage__deposits-tab .PaymentsTable .ReactTable .rt-thead .rt-tr .rt-th:last-child,
  .FinancesPage__deposits-tab .PaymentsTable .ReactTable .rt-tbody .rt-tr-group .rt-tr .rt-td:last-child {
    flex: 150 0 auto !important;
    min-width: 200px !important;
    width: 200px !important;

    @include respond-to(sm) {
      flex: 120 0 auto !important;
      min-width: 150px !important;
      width: 150px !important;
    }
  }

  /* CRM Withdrawals Tab - specific column widths */
  .FinancesPage__withdrawals-tab .PaymentsTable .ReactTable .rt-thead .rt-tr .rt-th:first-child,
  .FinancesPage__withdrawals-tab .PaymentsTable .ReactTable .rt-tbody .rt-tr-group .rt-tr .rt-td:first-child {
    flex: 80 0 auto !important;
    min-width: 80px !important;
    width: 80px !important;

    @include respond-to(sm) {
      flex: 60 0 auto !important;
      min-width: 60px !important;
      width: 60px !important;
    }
  }

  .FinancesPage__withdrawals-tab .PaymentsTable .ReactTable .rt-thead .rt-tr .rt-th:nth-child(2),
  .FinancesPage__withdrawals-tab .PaymentsTable .ReactTable .rt-tbody .rt-tr-group .rt-tr .rt-td:nth-child(2) {
    flex: 200 0 auto !important;
    min-width: 200px !important;
    width: 200px !important;

    @include respond-to(sm) {
      flex: 150 0 auto !important;
      min-width: 180px !important;
      width: 180px !important;
    }
  }

  .FinancesPage__withdrawals-tab .PaymentsTable .ReactTable .rt-thead .rt-tr .rt-th:last-child,
  .FinancesPage__withdrawals-tab .PaymentsTable .ReactTable .rt-tbody .rt-tr-group .rt-tr .rt-td:last-child {
    flex: 150 0 auto !important;
    min-width: 250px !important;
    width: 250px !important;

    @include respond-to(sm) {
      flex: 120 0 auto !important;
      min-width: 180px !important;
      width: 180px !important;
    }
  }
`;

export { staticStyles };
